var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTop30(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6701_505208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4488 20.6302L27.4736 19.3281V20.8152L29.4488 21.3656V20.6302Z",
    fill: "#A50E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.6302L2.52614 19.3281V20.8152L0.550781 21.3656V20.6302Z",
    fill: "#A50E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52637 8.05859V24.0586L15 32.0586L27.4736 24.0586V8.05859L15 0.0585938L2.52637 8.05859Z",
    fill: "#ECB20C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4712 13.2965L15 3.50899V0.0585938L2.52637 8.05859L10.4712 13.2965Z",
    fill: "url(#paint0_linear_6701_505208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9011 19.3281L15 28.6096V32.06L27.4736 24.06L24.7835 22.3347L20.9011 19.3281Z",
    fill: "url(#paint1_linear_6701_505208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7843 24.5093L5.21629 22.332L2.52637 24.0573L15 32.0573V28.6069L14.7843 24.5093Z",
    fill: "url(#paint2_linear_6701_505208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2131 7.75219L24.7835 9.78387L27.4736 8.05859L15 0.0585938V3.50899L15.2131 7.75219Z",
    fill: "url(#paint3_linear_6701_505208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9024 18.9036L5.62013 10.0656L2.52637 8.05859V24.0586L5.21629 22.3333L10.9024 18.9036Z",
    fill: "url(#paint4_linear_6701_505208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0977 18.9036L24.3799 10.0656L27.4738 8.05859V24.0586L24.7837 22.3333L19.0977 18.9036Z",
    fill: "url(#paint5_linear_6701_505208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21582 9.78269V22.3321L14.9995 28.607L24.783 22.3321V9.78269L14.9995 3.50781L5.21582 9.78269Z",
    fill: "url(#paint6_linear_6701_505208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90822 24.9426H1.79334C1.1071 24.9426 0.550781 24.3863 0.550781 23.7V20.5391H8.56502C9.30678 20.5391 9.90822 21.1403 9.90822 21.8823V24.9426Z",
    fill: "url(#paint7_linear_6701_505208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2057 25.216H20.0908V22.1557C20.0908 21.4139 20.6921 20.8125 21.434 20.8125H29.4483V23.9735C29.4483 24.6597 28.8919 25.216 28.2057 25.216Z",
    fill: "url(#paint8_linear_6701_505208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5808 27.418H7.41836C7.0454 27.418 6.74316 27.1156 6.74316 26.7428V22.0385C6.74316 21.6655 7.04556 21.3633 7.41836 21.3633H22.5809C22.9539 21.3633 23.2561 21.6657 23.2561 22.0385V26.7428C23.2561 27.1158 22.9537 27.418 22.5808 27.418Z",
    fill: "url(#paint9_linear_6701_505208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 28.7953C17.4322 28.7953 19.4037 26.8238 19.4037 24.3918C19.4037 21.9598 17.4322 19.9883 15.0002 19.9883C12.5682 19.9883 10.5967 21.9598 10.5967 24.3918C10.5967 26.8238 12.5682 28.7953 15.0002 28.7953Z",
    fill: "#F6F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9993 27.9595C16.9707 27.9595 18.5689 26.3613 18.5689 24.3899C18.5689 22.4185 16.9707 20.8203 14.9993 20.8203C13.0279 20.8203 11.4297 22.4185 11.4297 24.3899C11.4297 26.3613 13.0279 27.9595 14.9993 27.9595Z",
    fill: "#FFE066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 21.7266L15.866 23.4819L17.8033 23.7634L16.4016 25.1298L16.7325 27.059L14.9998 26.1482L13.267 27.059L13.598 25.1298L12.1963 23.7634L14.1334 23.4819L14.9998 21.7266Z",
    fill: "#FCC11A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 21.7266L15.1124 24.3363L15.866 23.4819L16.8347 23.6226L17.8033 23.7634L15.1124 24.3363L16.4016 25.1298L16.567 26.0944L16.7325 27.059L15.1124 24.3363L14.9998 26.1482L14.1334 26.6037L13.267 27.059L15.1124 24.3363L13.598 25.1298L12.8971 24.4466L12.1963 23.7634L15.1124 24.3363L14.1334 23.4819L14.5665 22.6042L14.9998 21.7266Z",
    fill: "#F38B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90768 9.82561L8.14368 8.88145C8.17392 8.76033 8.23664 8.64961 8.32496 8.56129C8.41328 8.47297 8.524 8.41025 8.64512 8.38001L9.58928 8.14401C9.61472 8.13761 9.61472 8.10145 9.58928 8.09521L8.64512 7.85921C8.524 7.82897 8.41328 7.76625 8.32496 7.67793C8.23664 7.58961 8.17392 7.47889 8.14368 7.35777L7.90768 6.41361C7.90128 6.38817 7.86512 6.38817 7.85888 6.41361L7.62288 7.35777C7.59264 7.47889 7.52992 7.58961 7.4416 7.67793C7.35328 7.76625 7.24256 7.82897 7.12144 7.85921L6.17728 8.09521C6.15184 8.10161 6.15184 8.13777 6.17728 8.14401L7.12144 8.38001C7.24256 8.41025 7.35328 8.47297 7.4416 8.56129C7.52992 8.64961 7.59264 8.76033 7.62288 8.88145L7.85888 9.82561C7.86528 9.85105 7.90144 9.85105 7.90768 9.82561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7224 20.1832L24.8993 19.475C24.922 19.3841 24.9691 19.3011 25.0353 19.2349C25.1016 19.1686 25.1846 19.1216 25.2755 19.0989L25.9836 18.9217C26.0027 18.9169 26.0027 18.8899 25.9836 18.8851L25.2755 18.708C25.1846 18.6853 25.1016 18.6382 25.0353 18.572C24.9691 18.5057 24.922 18.4227 24.8993 18.3318L24.7224 17.6237C24.7176 17.6046 24.6905 17.6046 24.6857 17.6237L24.5088 18.3318C24.486 18.4227 24.439 18.5057 24.3728 18.572C24.3065 18.6382 24.2235 18.6853 24.1326 18.708L23.4244 18.8851C23.4054 18.8899 23.4054 18.9169 23.4244 18.9217L24.1326 19.0989C24.2235 19.1216 24.3065 19.1686 24.3728 19.2349C24.439 19.3011 24.486 19.3841 24.5088 19.475L24.6857 20.1832C24.6905 20.2022 24.7176 20.2022 24.7224 20.1832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0333 15.7142V15.3406C15.0333 15.05 15.1025 14.7813 15.2409 14.5345C15.3818 14.2878 15.5856 14.0894 15.8521 13.9395C16.1186 13.7896 16.444 13.7146 16.8284 13.7146C17.2205 13.7146 17.5498 13.7896 17.8163 13.9395C18.0853 14.0871 18.2878 14.2843 18.4236 14.5311C18.562 14.7755 18.6312 15.0454 18.6312 15.3406V15.7142C18.6312 16.0048 18.562 16.2735 18.4236 16.5203C18.2852 16.767 18.0815 16.9654 17.8124 17.1153C17.5434 17.2652 17.2154 17.3402 16.8284 17.3402C16.4389 17.3402 16.1109 17.2652 15.8444 17.1153C15.5779 16.9654 15.3754 16.767 15.2371 16.5203C15.1012 16.2735 15.0333 16.0048 15.0333 15.7142ZM16.2595 15.3406V15.7142C16.2595 15.8618 16.2992 16.0037 16.3787 16.1397C16.4607 16.2758 16.6106 16.3438 16.8284 16.3438C17.0514 16.3438 17.2013 16.2781 17.2781 16.1466C17.355 16.0129 17.3935 15.8687 17.3935 15.7142V15.3406C17.3935 15.1861 17.3563 15.0408 17.282 14.9047C17.2102 14.7663 17.059 14.6971 16.8284 14.6971C16.6132 14.6971 16.4645 14.7663 16.3825 14.9047C16.3005 15.0408 16.2595 15.1861 16.2595 15.3406ZM10.9512 11.6597V11.2861C10.9512 10.9909 11.0216 10.7211 11.1626 10.4766C11.3061 10.2298 11.5111 10.0326 11.7776 9.88502C12.0441 9.73511 12.367 9.66016 12.7462 9.66016C13.1383 9.66016 13.4676 9.73511 13.7341 9.88502C14.0032 10.0326 14.2069 10.2298 14.3453 10.4766C14.4837 10.7211 14.5529 10.9909 14.5529 11.2861V11.6597C14.5529 11.9549 14.4824 12.2248 14.3414 12.4692C14.2031 12.7137 13.9993 12.9086 13.7303 13.0539C13.4612 13.1992 13.1332 13.2718 12.7462 13.2718C12.3593 13.2718 12.0313 13.198 11.7622 13.0504C11.4957 12.9028 11.2933 12.7068 11.1549 12.4623C11.0191 12.2179 10.9512 11.9503 10.9512 11.6597ZM12.1889 11.2861V11.6597C12.1889 11.8142 12.2286 11.9584 12.308 12.0922C12.3901 12.2236 12.5361 12.2893 12.7462 12.2893C12.9718 12.2893 13.1217 12.2236 13.196 12.0922C13.2729 11.9584 13.3113 11.8142 13.3113 11.6597V11.2861C13.3113 11.1316 13.2754 10.9863 13.2037 10.8502C13.1319 10.7118 12.9794 10.6426 12.7462 10.6426C12.531 10.6426 12.3836 10.713 12.3042 10.8537C12.2273 10.9944 12.1889 11.1385 12.1889 11.2861ZM11.5316 17.0426L16.9437 9.95767H17.9931L12.581 17.0426H11.5316Z",
    fill: "#F28500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6701_505208",
    x1: 8.80256,
    y1: 4.10736,
    x2: 10.6621,
    y2: 6.40503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6701_505208",
    x1: 20.8514,
    y1: 27.5096,
    x2: 19.5083,
    y2: 25.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6701_505208",
    x1: 8.59408,
    y1: 28.2356,
    x2: 10.8313,
    y2: 25.8759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDA416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6701_505208",
    x1: 21.3559,
    y1: 3.93891,
    x2: 19.1183,
    y2: 6.32757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDA416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6701_505208",
    x1: 2.5263,
    y1: 16.0586,
    x2: 5.60771,
    y2: 16.0586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6701_505208",
    x1: 27.4738,
    y1: 16.0586,
    x2: 24.3924,
    y2: 16.0586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6701_505208",
    x1: 14.9994,
    y1: 28.607,
    x2: 14.9994,
    y2: 3.50786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD12D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCED6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6701_505208",
    x1: 0.550781,
    y1: 22.7409,
    x2: 9.90816,
    y2: 22.7409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE4244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33730"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6701_505208",
    x1: 20.0909,
    y1: 23.0143,
    x2: 29.4483,
    y2: 23.0143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE4244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33730"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6701_505208",
    x1: 14.9996,
    y1: 27.418,
    x2: 14.9996,
    y2: 21.3632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF544A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7726E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6701_505208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8978,
    height: 32,
    fill: "white",
    transform: "translate(0.550781 0.0585938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop30);
export default __webpack_public_path__ + "static/media/top30.aba95cc9925d808e9b9e076a68978106.svg";
export { ForwardRef as ReactComponent };